import script from "./DatenschutzerklaerungModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DatenschutzerklaerungModal.vue?vue&type=script&setup=true&lang=js"

import "./DatenschutzerklaerungModal.vue?vue&type=style&index=0&id=065870bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065870bb"]])

export default __exports__